module.exports = __webpack_public_path__ + "static/media/pcbang.9ee3a3d6.jpg";